export const SET_QUERY_PARAMS_DATA = "SET_URL_PARAMS_DATA";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const CLEAR_PREVIOUS_ROUTE = "CLEAR_PREVIOUS_ROUTE";

export const setQueryParamsData = (queryParamsData: any) => {
    return {
        type: SET_QUERY_PARAMS_DATA,
        payload: queryParamsData
    }
};

export const setCurrentRoute = (currentRoute: string, overridePrevRoute: boolean = false) => {
    return {
        type: SET_CURRENT_ROUTE,
        payload: {
            currentRoute,
            overridePrevRoute
        }
    }
};

export const clearPreviousNav = () => {
    return {
        type: CLEAR_PREVIOUS_ROUTE
    }
};